import { UserWebmapGebiet } from "../context/authenticationContext";

// group label for gebiete categories
export type gebieteKategorie =
  | "bundesland"
  | "wahlkreis_btw"
  | "wahlbezirk_ltw"
  | "wahlkreis_ltw"
  | "regierungsbezirk"
  | "landkreis"
  | "verbundsgemeinde"
  | "gemeinde";

export const gebieteGroupLabel: { [k in gebieteKategorie]: string } = {
  bundesland: "Bundesland",
  regierungsbezirk: "Regierungsbezirke",
  wahlkreis_btw: "Wahlkreise Bundestagswahl",
  wahlkreis_ltw: "Wahlkreise Landtagswahl",
  landkreis: "Landkreise",
  wahlbezirk_ltw: "Wahlbezirke Landtagswahl",
  verbundsgemeinde: "Verbundsgemeinden",
  gemeinde: "Gemeinden",
};

export function sortGebiete(a: UserWebmapGebiet, b: UserWebmapGebiet) {
  return (
    Object.keys(gebieteGroupLabel).indexOf(a.kategorie) -
    Object.keys(gebieteGroupLabel).indexOf(b.kategorie)
  );
}
